(ns practitest.frontend.global-fields-settings.confirmation-modal
  (:require
    [practitest.frontend.components.icons :as icons]
     [practitest.frontend.components.modal :as modal]
     [practitest.frontend.components2.buttons :as buttons]
     [practitest.frontend.common.dom :as dom]))

(defn delete-confirmation-modal [{:keys [show? show-footer? title body on-delete on-cancel confirmation-button-text cancel-button-text modal-class show-icon? icon header-class destructive?]}]
  [:<>
   [modal/bootstrap-modal
    {:class (dom/append-class "global-delete-modal" modal-class)
     :is-open? @show?
     :on-request-close on-cancel
     :close-button? true
     :centered? true
     :footer-class "justify-content-center"
     :title-class "justify-content-center"}
    ;;Header
     [:<>
      (when (not (false? show-icon?))
        (or icon [icons/mux-notification-error]))
      [:p {:class header-class} title]]
    ;;Body
     [:div.delete-modal-body body]
    ;;Footer
     (when show-footer?
       [:<>
         (when cancel-button-text
           [buttons/button {:size "large"
                            :on-click on-cancel
                            :text cancel-button-text}])
         [buttons/button {:primary? true
                          :size "large"
                          :class (when destructive? "btn-delete")
                          :on-click on-delete
                          :text confirmation-button-text}]])]])